import {Component, OnInit, Sanitizer} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BankTransferLoad} from '../../../dto/bankTransferLoad';
import {IdvUploadDto, SofDecisionDto} from '../../../dto/idv-upload';
import {BankTransferLoadService} from '../../../bank-transfer-load.service';
import {CustomersService} from '../../services/customers.service';
import {DatePipe, Location} from '@angular/common';
import {Customer} from '../../../dto/customer';
import {TrustPayTransaction} from '../../../dto/trustPayTransaction';
import {TrustPayService} from '../../../trust-pay.service';
import {toDateTimeString} from '../../../providers/app-date-adapter';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ToastService} from 'angular-toastify';

@Component({
  selector: 'app-sof-btl-detail',
  templateUrl: './sof-btl-detail.component.html',
  styleUrls: ['./sof-btl-detail.component.css']
})
export class SofBtlDetailComponent implements OnInit {
  private btlId: number;
  bankTransferLoad: BankTransferLoad|null;
  trustPayTransaction: TrustPayTransaction|null;
  uploadedFiles: IdvUploadDto[] = [];
  isLoading = false;
  customer: Customer|null;
  previewFileOpen = false;
  urlSafe: SafeResourceUrl;
  isImgHidden = false;
  isFrameHidden = false;
  filename = '';
  errorMsg = '';

  decisionNecessary = false;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private bankTransferLoadService: BankTransferLoadService,
    private customersService: CustomersService,
    private location: Location,
    private trustPayService: TrustPayService,
    public datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private _toastService: ToastService,

  ) { }


  fieldsTransaction = [
    {columnDef: 'createDate', header: 'Created', cell: (row: TrustPayTransaction) => `${toDateTimeString(row.createDate) || ''}`},
    {columnDef: 'statementDate', header: 'Statement', cell: (row: TrustPayTransaction) => `${toDateTimeString(row.statementDate) || ''}`},
    {columnDef: 'source', header: 'Source', cell: (row: TrustPayTransaction) => {
      switch (row.source) {
        case 0 : return "Revolut";
        case 1 : return "Trustpay";
        case 2 : return "Qonto";
        case 3 : return "Commerzbank";
        case 4 : return "MicroPayment";
      }
        return "Unknown";
      }},
    {columnDef: 'amount', header: 'Amount', cell: (row: TrustPayTransaction) => `${row.amount.formatMoneyEuro()}`},
    {columnDef: 'reference', header: 'Reference', cell: (row: TrustPayTransaction) => `${row.reference || '(missing)'}`},
    {columnDef: 'description', header: 'Description', cell: (row: TrustPayTransaction) => `${row.description || '(missing)'}`},
    {columnDef: 'counterAccount', header: 'CounterAccount', cell: (row: TrustPayTransaction) => `${row.counterAccountMasked}`},
    {columnDef: 'counterAccountName', header: 'CounterAccountName', cell: (row: TrustPayTransaction) => `${row.counterAccountName}`},
    {columnDef: 'card', header: 'Card', cell: (row: TrustPayTransaction) => `${row.cardFound ? row.cardFound.token : '-'}`},

  ];
  decision = 0;
  decisionComment = '';
  decisionCustomerIncome: number|null;
  decisionCustomerIncomeType: number|null;
  notAllFilesStatusSet = true;
  isSavingDecision = false;

  ngOnInit(): void {
    this.btlId = parseInt(this.route.snapshot.paramMap.get( 'id' ));
    this.loadData();
  }

  loadData(): void {

    this.isLoading = true;

    this.bankTransferLoadService.get(this.btlId).subscribe(btl => {
      this.bankTransferLoad = btl;
      this.customersService.get(this.bankTransferLoad.card.customerId).subscribe(customer => {
        this.customer = customer;
      });
      if ( btl.trustPayTransactionId ) {
        this.trustPayService.get(btl.trustPayTransactionId).subscribe(data => {
          this.trustPayTransaction = data;
        });
      }
    });
    this.bankTransferLoadService.getSofSingleUploads(this.btlId).subscribe(btl => {
      this.uploadedFiles = btl;
      this.uploadedFiles.forEach(f => {
        if ( f.isSuccess === null ) {
this.decisionNecessary = true;
}
      });
      this.handleFileStatusChange();
      this.isLoading = false;
    });

  }

  returnBack() {
    this.location.back();
  }

  previewFile(fileId: number) {
    this.isLoading = true;
    this.previewFileOpen = true;
    this.customersService.getFileInline( fileId ).subscribe(
      result => {

        const disposition = result.headers.get('Content-Disposition');
        const contentType = result.headers.get('Content-Type');
        const filename = disposition.split(';')[1].trim().split('=')[1];

        const blob = new Blob([result.body], { type: contentType });
        // FileSaver.saveAs(blob , filename);
        const fileURL = URL.createObjectURL(blob);


        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

        if ( contentType.indexOf('image') >= 0) {
          this.isImgHidden = false;
          this.isFrameHidden = true;

        } else {
          this.isImgHidden = true;
          this.isFrameHidden = false;

        }
        this.errorMsg = null;
        this.filename = filename;



        this.isLoading = false;

        // FileHelper.saveFile( result );
      },
      err => {
        this.filename = null;
        this.isImgHidden = true;
        this.isFrameHidden = true;
        this.errorMsg = 'Error occured during downloading the file.';
        this.isLoading = false;
        this._toastService.error( err.error.message || err.message || err.error || err);
      }

    );
  }

  closePreview() {
    this.previewFileOpen = false;
  }

  saveDecision() {
    const decisionDto = {
      decision: this.decision,
      decisionComment: this.decisionComment,
      customerIncome: this.decisionCustomerIncome,
      customerIncomeType: this.decisionCustomerIncomeType,
      files: this.uploadedFiles,
      bankTransferLoadId: this.btlId,
      customerId: this.bankTransferLoad.card.customerId,
      customerYearlyIncome: this.decisionCustomerIncome,
      customerMainIncomeSource: this.decisionCustomerIncomeType,

    } as SofDecisionDto;

    this.isSavingDecision = true;
    this.customersService.saveSofDecision(decisionDto).subscribe(data => {
      this._toastService.success('The decision was saved and the customer informed');
      this.isSavingDecision = false;

      this.router.navigate(['../../../idv-customers-overview/' + this.customer.id], {relativeTo: this.route});

    }, err => {
      this._toastService.error(err.error.message || err.error || err.message);
      this.isSavingDecision = false;
    });


  }

  handleFileStatusChange() {
    let allSet = true;
    this.uploadedFiles.forEach(uf => {
      if ( uf.isSuccess === null ) {
        allSet = false;
      }
    });
    this.notAllFilesStatusSet = !allSet;
  }
}
